import { useContext, useCallback } from 'react'
import Button from '@mui/material/Button'
import { TableToolbar } from '@components/layout/toolbars/tableToolbar'
import { CreateDatasetContext } from '@datasets/reducer/context'
import { colors } from '@global/constants'
import { useAppSelector } from '@redux/hooks'
import { t } from '@lingui/core/macro'

interface Props {
  hasDataset: boolean
  onErrorClick: () => void
  submit: () => void
  submitDisabled: boolean
  templateId: string
  tableRef: any
  updatedAt: string
}

export const ResubmitToolbar = ({
  templateId,
  tableRef,
  submit,
  onErrorClick,
  submitDisabled = false,
  updatedAt,
  hasDataset,
}: Props) => {
  const submissionTemplate = useAppSelector(
    state => state.Datasets.submissionTemplatesById[templateId],
  )
  const { state } = useContext(CreateDatasetContext)
  const { errors, errorCount } = state
  const showSubmissionStatus = Boolean(updatedAt) && hasDataset

  const onSearch = useCallback(
    e => {
      if (e.key !== 'Enter') return
      // this logic is only going to work with handsontable. Read Table needs it's own search.
      const searchTerm = e.target.value
      const currentSelection = tableRef?.current?.getSelectedLast()
      const startingPoint = currentSelection ? currentSelection[0] : 0
      const startingCol = currentSelection ? currentSelection[1] + 1 : 0
      let exit = false
      const data = tableRef?.current.getData()
      for (let index = startingPoint; index < data.length; index++) {
        for (let colIdx = 0; colIdx < data[index].length; colIdx++) {
          if (index === startingPoint && colIdx < startingCol) {
            // wasted column
          } else if (
            data[index][colIdx]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            tableRef?.current.selectCell(index, colIdx)
            tableRef?.current.unlisten()
            exit = true
            break
          }
        }
        if (exit) {
          break
        }
      }

      if (!exit) {
        let secondExit = false
        for (let index = 0; index < startingPoint; index++) {
          for (let colIdx = 0; colIdx < data[index].length; colIdx++) {
            if (index === startingPoint && colIdx < startingCol) {
              // wasted column
            } else if (
              data[index][colIdx]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
            ) {
              tableRef?.current.selectCell(index, colIdx)
              tableRef?.current.unlisten()
              secondExit = true
              break
            }
          }
          if (secondExit) {
            break
          }
        }
      }
      const { target } = e
      e.stopPropagation()
      target.focus()
      setTimeout(() => {
        target.focus()
        target.click()
      }, 200)
      setTimeout(() => {
        target.focus()
        target.click()
      }, 100)
    },
    [tableRef?.current],
  )

  return (
    <TableToolbar
      template={submissionTemplate}
      errors={errors}
      errorCount={errorCount}
      onErrorClick={onErrorClick}
      onKeyPress={onSearch}
      submissionStatus={
        showSubmissionStatus && (
          <span
            style={{
              backgroundColor: colors.green.main,
              color: colors.white,
              fontSize: 12,
              padding: '4px 8px',
              borderRadius: 50,
              marginLeft: '10px',
            }}
          >
            {t`Draft`}
          </span>
        )
      }
    >
      <Button
        size="large"
        variant="contained"
        color="primary"
        onClick={submit}
        disabled={submitDisabled}
        style={{ boxShadow: 'none' }}
      >
        {t`Submit`}
      </Button>
    </TableToolbar>
  )
}
